export enum EUpdateMode {
	ADRi = "adri",
	carteVitale = "cv",
	manual = "manual",
}
